export enum UserActions {
  Add = 'ADD',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Detail = 'DETAIL',
  Reprove = 'REPROVE',
  Approve = 'APPROVE',
}
